<template>
  <div
    id="multiple"
    :class="`card card px-${space} py-${space} mt-${space} wrapper-multiples`"
  >
    <div>
      <button class="btn" style="box-shadow: none" @click="visible = !visible">
        <i class="fas fa-check-circle"></i>
        {{ $t('reports.multipleSubOptions.multipleSubOptions') }}
      </button>
      <button
        class="btn pull-right"
        style="box-shadow: none"
        @click="visible = !visible"
      >
        <i class="fas fa-angle-double-right" v-if="!visible"></i>
        <i v-else class="fas fa-angle-double-down"></i>
      </button>
      <div class="radio">
        <b-form-radio-group
          id="type-radio-group"
          name="radio-calculation"
          :value="averageByAnswers"
          v-model="averageByAnswers"
        >
          <b-form-radio name="frequency-radio" value="false">
            {{ $t('reports.multipleSubOptions.optionFrequency') }}
          </b-form-radio>
          <b-form-radio name="answer-radio" value="true">
            {{ $t('reports.multipleSubOptions.optionAnswer') }}
          </b-form-radio>
        </b-form-radio-group>

        <font-awesome-icon
          id="category-option-info"
          :icon="['fas', 'info-circle']"
          style="font-size: 15px; color: #c1c1c1"
        />
        <b-popover
          target="category-option-info"
          triggers="hover"
          placement="bottom"
        >
          <b>{{ $t('reports.multipleSubOptions.optionFrequency') }}</b> -
          Cálculo: Opção / Total de opções.<br />
          <br />
          <b>{{ $t('reports.multipleSubOptions.optionAnswer') }}</b> - Cálculo:
          Opção / Total de respostas.
        </b-popover>
      </div>
    </div>
    <div class="wrapper-rankings card" v-if="loader">
      <div>
        <table
          style="margin-top: 25px; color: #000"
          v-for="(item, index) in fakeTableByLoading"
          :key="index"
        >
          <thead>
            <tr>
              <th>{{ item.question }}</th>
              <th></th>
              <th>Score</th>
              <th>Total</th>
            </tr>
          </thead>
          <tbody
            v-for="(option, indexOption) in item.options"
            :key="indexOption"
          >
            <tr>
              <td>
                <idx-skeleton width="80" height="15" radius="10" />
              </td>
              <td style="vertical-align: top; padding-top: 18px">
                <idx-skeleton width="80" height="15" radius="10" />
              </td>
              <td style="vertical-align: top; padding-top: 18px">
                <idx-skeleton width="80" height="15" radius="10" />
              </td>
              <td style="vertical-align: top; padding-top: 18px">
                <idx-skeleton width="80" height="15" radius="10" />
              </td>
            </tr>
          </tbody>
          <tr>
            <td colspan="3" style="border: none">
              <span>Total de respostas</span>
            </td>
            <td colspan="1" style="border: none">
              <idx-skeleton width="80" height="15" radius="10" />
            </td>
          </tr>
        </table>
      </div>
    </div>
    <div v-else>
      <b-collapse v-model="visible" class="mt-2">
        <table
          style="margin-top: 25px; color: #000"
          v-for="(item, index) in multiplesData"
          :key="index"
        >
          <thead>
            <tr>
              <th>{{ item.question }}</th>
              <th></th>
              <th>Score</th>
              <th style="display: flex;">
                <span class="icon" style="display: block;" :id="`icon-sort-default-${index}`" @click="orderQuestion('fromSmallestToLargest', index)">
                  <img
                    :src="iconDefault"
                    class="icon-sort"
                  />
                </span>
                <span class="icon" style="display: none;" :id="`icon-sort-big-${index}`" @click="orderQuestion('fromSmallestToLargest', index)">
                  <img
                    :src="iconBiggerToSmallest"
                    class="icon-sort"
                  />
                </span>
                <span class="icon" style="display: none;" :id="`icon-sort-small-${index}`" @click="orderQuestion('fromBiggestToSmallest', index)">
                  <img
                    :src="iconSmallestToBigger"
                    class="icon-sort"
                  />
                </span>
                Total
              </th>
            </tr>
          </thead>
          <tbody
            v-for="(option, indexOption) in item.options"
            :key="indexOption"
          >
            <tr>
              <td>
                <b-button
                  :id="`arrow-down${index}${indexOption}`"
                  @click="hideSubOption(index, indexOption)"
                  class="m-1 btn btn-outline"
                  style="display: none"
                >
                  <span>
                    <i class="fas fa-caret-down" style="margin-left: -3px" />
                  </span>
                  {{ option.text }}
                </b-button>

                <b-button
                  @click="showSubOption(index, indexOption)"
                  :id="`arrow-right${index}${indexOption}`"
                  class="m-1 btn btn-outline"
                  style="display: block"
                >
                  <span>
                    <i
                      :id="`arrow-right${index}${indexOption}`"
                      @click="hideSubOption(index, indexOption)"
                      class="fas fa-caret-right"
                      style="margin-left: -3px"
                    />
                  </span>
                  {{ option.text }}
                </b-button>
              </td>
              <td style="vertical-align: top; padding-top: 18px">
                <b-progress :value="option.progress" :max="100"></b-progress>
              </td>
              <td style="vertical-align: top; padding-top: 18px">
                {{ option.score }}
              </td>
              <td style="vertical-align: top; padding-top: 18px;padding-left: 10px;">
                <span class="align-total">{{ option.qtd }}</span>
              </td>
            </tr>
            <tr
              :class="`accordion${index}${indexOption}`"
              style="display: none"
              v-for="(subOption, indexSubOption) in option.subOptions"
              :key="indexSubOption"
            >
              <td style="padding-left: 40px">{{ subOption.text }}</td>
              <td>
                <b-progress :value="subOption.progress" :max="100"></b-progress>
              </td>
              <td>{{ subOption.score }}</td>
              <td>{{ subOption.qtd }}</td>
            </tr>
          </tbody>
          <tr>
            <td colspan="3" style="border: none">
              <span>Total de respostas</span>
            </td>
            <td colspan="1" style="border: none">
              <span class="align-total">{{item.total}}</span>
            </td>
          </tr>
        </table>
        <div class="row">
          <!-- <div class="col-12 mt-2 text-right">
            <a
              @click="exportToXLS"
              :title="`${this.$t('reports.exportXlsLabel')}`"
            >
              <span class="xls">
                <i class="fas fa-file-download"></i>
              </span>
            </a>
          </div> -->
        </div>
      </b-collapse>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import XLSX from 'xlsx';
import EmptyState from '@/components/molecules/empty-state';
import idxSkeleton from '@/components/molecules/idx-skeleton';
import api from '@/services/api';
import EventBus from '../../../../../../eventBus';
// import ces from '../../     ../../../../../assets/addquestion-ces.png';
import iconBiggerToSmallest from '../../../../../../assets/sort-bigger.png';
import iconDefault from '../../../../../../assets/sort-default.png';
import iconSmallestToBigger from '../../../../../../assets/sort-smallest.png';

export default {
  name: 'MultipleWithSubOptions',

  components: {
    EmptyState,
    idxSkeleton,
    iconBiggerToSmallest,
    iconDefault,
    iconSmallestToBigger
  },

  data: () => ({
    isBusy: false,
    empty: false,
    filter: null,
    userAuth: null,
    visible: true,
    total: 0,
    totalAnswers: 0,
    page: 1,
    limit: 10,
    items: [],
    multiplesData: [],
    loader: false,
    fields: [],
    arrayFields: [],
    lang: 'br',
    space: 2,
    averageByAnswers: false,
    fakeTableByLoading: [
      {
        question: 'Escolha uma alternativa',
        options: [
          {
            text: 'Opção 1',
            qtd: 25,
            progress: '76',
            score: '63',
            totalAnswer: 200,
            subOptions: [
              {
                qtd: 75,
                text: 'SubOpção 1',
                progress: '45',
                score: '45',
              },
              {
                qtd: 35,
                text: 'SubOpção 2',
                progress: '48',
                score: '48',
              },
            ],
          },
          {
            text: 'Atendimento',
            qtd: 25,
            progress: '30',
            score: '63',
            totalAnswer: 350,
            subOptions: [
              {
                qtd: 75,
                text: 'Atendimento - Central',
                progress: '45',
                score: '45',
              },
              {
                qtd: 35,
                text: 'Atendimento - Unilateral',
                progress: '48',
                score: '48',
              },
            ],
          },
        ],
      },
      {
        question: 'Podemos entrar em contato?',
        options: [
          {
            text: 'Opção 2 - itens',
            qtd: 5,
            progress: '55',
            score: '80',
            totalAnswer: 120,
            subOptions: [
              {
                qtd: 15,
                text: 'SubOpção 1 - Adqurido',
                progress: '30',
                score: '33',
              },
              {
                qtd: 2,
                text: 'SubOpção 02 - Em analise',
                progress: '49',
                score: '41',
              },
            ],
          },
        ],
      },
    ],
    orderBy: 'default',
    iconBiggerToSmallest,
    iconDefault,
    iconSmallestToBigger
  }),

  watch: {
    averageByAnswers: function watchAverageByOption() {
      this.mountMultiples();
    },

    actionGroupData: function watchActionGroupData() {
      this.mountMultiples();
    },
    myActionId: function watchMyActionId() {
      this.mountMultiples();
    },
    myActionsIds: function watchMyActionsIds() {
      this.mountMultiples();
    },
    myIh1: function watchMyIh1() {
      this.mountMultiples();
    },
    myHierarchies1: function watchMyHierarchies1() {
      this.mountMultiples();
    },
    myIh2: function watchMyIh2() {
      this.mountMultiples();
    },
    myHierarchies2: function watchMyHierarchies2() {
      this.mountMultiples();
    },
    calendarDates: function watchDates() {
      this.mountMultiples();
    },
    myMetric: function watchMyMetric() {
      this.mountMultiples();
    },
    'indicatorData.value': function watchMyMetric() {
      this.mountMultiples();
    },
    'indicatorData.period': async function watchIndicatorPeriod() {
      await this.mountMultiples();
    },
    '$i18n.locale': function watchLocale(value) {
      this.lang = value;
      this.mountMultiples();
    },
  },

  computed: {
    ...mapState('charts', ['filterRankings']),
    ...mapState('actions', ['myActionId', 'actionGroupData', 'myActionsIds']),
    ...mapState('calendar', ['calendarDates']),
    ...mapState('branches', ['myIh1', 'myIh2', 'myHierarchies1', 'myHierarchies2']),
    ...mapState('companies', ['myMetric']),
    ...mapState('indicators', ['indicatorName', 'indicatorData']),
  },

  methods: {
    orderQuestion(type, index){
      if (type === 'fromBiggestToSmallest') {
        document.getElementById(`icon-sort-big-${index}`).style.display = 'block';
        document.getElementById(`icon-sort-small-${index}`).style.display = 'none';
        document.getElementById(`icon-sort-default-${index}`).style.display = 'none';
        this.multiplesData[index].options = this.multiplesData[index].options.sort((a, b) => b.qtd - a.qtd);
      } else {
        document.getElementById(`icon-sort-small-${index}`).style.display = 'block';
        document.getElementById(`icon-sort-default-${index}`).style.display = 'none';
        document.getElementById(`icon-sort-big-${index}`).style.display = 'none';
        this.multiplesData[index].options = this.multiplesData[index].options.sort((a, b) => a.qtd - b.qtd);
      }
    },

    showSubOption(index, indexOption) {
      document.getElementById(
        `arrow-down${index}${indexOption}`,
      ).style.display = 'block';

      document.getElementById(
        `arrow-right${index}${indexOption}`,
      ).style.display = 'none';

      const rows = document.querySelectorAll(
        `.accordion${index}${indexOption}`,
      );

      rows.forEach((item) => {
        item.style.display = 'table-row';
      });
    },

    hideSubOption(index, indexOption) {
      document.getElementById(
        `arrow-down${index}${indexOption}`,
      ).style.display = 'none';

      document.getElementById(
        `arrow-right${index}${indexOption}`,
      ).style.display = 'block';

      const rows = document.querySelectorAll(
        `.accordion${index}${indexOption}`,
      );

      rows.forEach((item) => {
        item.style.display = 'none';
      });
    },

    async mountMultiples() {
      this.loader = true;
      const response = await api.get(`reports/multiples-with-suboptions`, {
        headers: { 'x-access-token': this.userAuth.token },
        params: {
          filter: this.filterRankings ? this.filterRankings : null,
          companyId: this.userAuth.companyId,
          actionId: this.myActionsIds.length === 0 ? null : this.myActionsIds.join(','),
          startDate: this.calendarDates.start ? this.calendarDates.start : null,
          endDate: this.calendarDates.end ? this.calendarDates.end : null,
          ih1: this.myHierarchies1.length === 0 ? null : this.myHierarchies1.join(','),
          ih2: this.myHierarchies2.length === 0 ? null : this.myHierarchies2.join(','),
          metric: this.myMetric ? this.myMetric : null,
          groupId: this.actionGroupData._id,
          indicator: this.indicatorName,
          indicatorValue: this.indicatorData.value,
          indicatorRange: this.indicatorData.range,
          lang: this.lang,
          averageByAnswers: this.averageByAnswers,
        },
      });
      this.multiplesData = response.data;

      this.items = [];
      this.totalAnswers = this.multiplesData.totalAnswers;

      this.loader = false;
    },

    s2ab(s) {
      const buf = new ArrayBuffer(s.length);
      const view = new Uint8Array(buf);
      // eslint-disable-next-line
      for (let i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xff;
      return buf;
    },

    exportToXLS() {
      const header = [
        this.$t('reports.reviews.addQuestionLabel'),
        'Value',
        this.$t('reports.multiples.scoreLabel'),
        this.$t('reports.multiples.totalLabel'),
      ];
      const arr = [];
      for (let i = 0; i < this.items.length; i += 1) {
        const fields = this.items[i].arrayFields;
        const items = this.items[i].arrayItems;
        const field = fields[0].label;
        items.forEach((el) => {
          arr.push({
            [this.$t('reports.reviews.addQuestionLabel')]: field,
            Value: el.question,
            [this.$t('reports.multiples.scoreLabel')]: el.score,
            [this.$t('reports.multiples.totalLabel')]: el.total,
          });
        });
      }
      const wb = XLSX.utils.book_new();
      wb.SheetNames.push('rankings-multiples');
      const ws = XLSX.utils.json_to_sheet(arr, { header });
      wb.Sheets['rankings-multiples'] = ws;
      const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'binary' });
      const uri = window.URL.createObjectURL(
        new Blob([this.s2ab(wbout)], { type: 'application/octet-stream' }),
      );
      const link = document.createElement('a');
      link.href = uri;
      link.setAttribute('download', 'rankings-multiples.xlsx');
      document.body.appendChild(link);
      link.click();
    },
  },

  created() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));
  },

  mounted() {
    this.visible = !this.showCollapsed;

    this.lang = this.$i18n.locale;

    this.mountMultiples();
    EventBus.$on('filter-rankings', () => {
      this.mountMultiples();
    });
  },
};
</script>

<style scoped lang="scss">
@import '@/themes/default/variables.scss';
.align-total {
  justify-content: center;
  align-items: center;
  display: flex;
}

.icon {
  width: 10px;
  margin-right: 8px;
  cursor: pointer;

  .icon-sort {
    width: 10px;
    margin-bottom: 6px;
    height: 18px;
  }
}

.radio {
  display: flex;
  float: right;
  margin-top: 8px;
}

.btn-outline {
  background: #fff;
  border: none;
  height: 25px;
  padding: 0;
}

tr td {
  border-bottom: 1px solid #d9d9d9;
  padding: 10px;
}

th {
  border-bottom: 1px solid #d9d9d9;
  padding: 10px;
  width: 85%;
  color: #000;
}

.arrow-toggle {
  position: absolute;
  left: -40px;
  top: 0;
}

table {
  width: 100%;
}

.no-padding {
  padding: 0;
}
.table {
  margin: 0;
}
.wrapper-multiples .table > thead > tr:nth-child(2) {
  display: none;
}
.wrapper-multiples .btn .btn-light .collapsed {
  background-color: transparent;
}
.wrapper-rankings.card {
  min-height: 200px;
}
.wrapper-rankings .loader {
  min-height: 200px;
}
.card {
  border: 1px solid #fff;
}
.card-panel {
  border: 1px solid #fff;
}
.hidden_header {
  display: none;
}
.xls {
  font-size: 35px;
  color: $primary;
  cursor: pointer;
  transition: color 0.2s;
  &:hover {
    color: #1dc86e;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/molecules/highcharts/reports/rankings/components/multiple-custom.vue